var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
import { useStores } from 'src/common/stores/use-stores';
import { PaginationNavigation } from './pagination-navigation-buttons';
import { ShowMoreButton } from './show-more-button';
export const Pagination = ({
  handleNext,
  handlePrev
}) => {
  var _a, _b, _c, _d, _e, _f;
  const {
    context,
    experiment,
    searchResults
  } = useStores();
  if (!context || !experiment || !((_a = searchResults === null || searchResults === void 0 ? void 0 : searchResults.pagination) === null || _a === void 0 ? void 0 : _a.trigger)) {
    return null;
  }
  const _g = searchResults.pagination.trigger,
    {
      __typename: type
    } = _g,
    trigger = __rest(_g, ["__typename"]),
    {
      isPaginationLoading
    } = searchResults;
  switch (type) {
    case 'LodgingPaginationNavigationButtons':
      return searchResults.isTotalPropertyCountLessThanInitialListingFetchCount(context, experiment) ? null : React.createElement(PaginationNavigation, {
        isLoading: isPaginationLoading,
        onNextPage: handleNext,
        onPrevPage: handlePrev,
        paginationLabel: (_b = searchResults.pagination.paginationLabel) !== null && _b !== void 0 ? _b : '',
        pagingNextButton: trigger === null || trigger === void 0 ? void 0 : trigger.nextButton,
        pagingPrevButton: trigger === null || trigger === void 0 ? void 0 : trigger.previousButton
      });
    case 'UIPrimaryButton':
      return searchResults.thereAreMoreListingsToFetch ? React.createElement(ShowMoreButton, {
        isLoading: isPaginationLoading,
        linkName: (_d = (_c = trigger === null || trigger === void 0 ? void 0 : trigger.analytics) === null || _c === void 0 ? void 0 : _c.linkName) !== null && _d !== void 0 ? _d : '',
        rfrr: (_f = (_e = trigger === null || trigger === void 0 ? void 0 : trigger.analytics) === null || _e === void 0 ? void 0 : _e.referrerId) !== null && _f !== void 0 ? _f : '',
        onNextSubset: handleNext
      }) : null;
    default:
      return null;
  }
};